/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.commerce.buyer.portal.rpc.BuyerBillingDataRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const getLatestObjectsRpc = {
  serviceName: 'com.hubspot.commerce.buyer.portal.rpc.BuyerBillingDataRpc',
  rpcName: 'getLatestObjects',
  auth: 'external',
  fingerprint: 'jLvVq79MF2txorbN_83yd5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getObjectDetailsRpc = {
  serviceName: 'com.hubspot.commerce.buyer.portal.rpc.BuyerBillingDataRpc',
  rpcName: 'getObjectDetails',
  auth: 'external',
  fingerprint: 'gk200FDcYv1o28FZ70znxpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPaymentMethodsRpc = {
  serviceName: 'com.hubspot.commerce.buyer.portal.rpc.BuyerBillingDataRpc',
  rpcName: 'getPaymentMethods',
  auth: 'external',
  fingerprint: 'w240K-5axTxVJfn9TZGDppwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getActiveSubscriptionsRpc = {
  serviceName: 'com.hubspot.commerce.buyer.portal.rpc.BuyerBillingDataRpc',
  rpcName: 'getActiveSubscriptions',
  auth: 'external',
  fingerprint: 'QtTlMOeQD3F8I9e-fXeC8JwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getInvoicesRpc = {
  serviceName: 'com.hubspot.commerce.buyer.portal.rpc.BuyerBillingDataRpc',
  rpcName: 'getInvoices',
  auth: 'external',
  fingerprint: '5yXOJmgQrLK7iQaRUmgcKJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getCommercePaymentsRpc = {
  serviceName: 'com.hubspot.commerce.buyer.portal.rpc.BuyerBillingDataRpc',
  rpcName: 'getCommercePayments',
  auth: 'external',
  fingerprint: 'C-c_6ghgT4MHzzD1J2ZV6pwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};